module.exports = __webpack_public_path__ + "media/auto_history/rok_produkcji-b2c52e25.svg";